<template>
    <div class="group relative flex flex-col justify-center overflow-visible">
        <component
            :is="url ? 'a' : 'div'"
            class="absolute zi-10 flex max-w-full items-center justify-center space-x-2 self-center rounded-md bg-white/80 px-2 py-1 text-gray-500 opacity-0 shadow-md transition-opacity duration-300 ease-in-out group-hover:opacity-100"
            :class="{
                'hover:bg-white/100 hover:text-gray-600': !!url,
                'cursor-not-allowed': !url,
            }"
            :href="url"
            target="_blank"
            @click.prevent="openLink(url)"
        >
            <span class="truncate text-center">{{ name }}</span>
            <base-icon
                v-if="url"
                name="external-link-square-alt"
                size="sm"
            />
        </component>
        <crm-logo
            class="filter duration-300 ease-in-out group-hover:blur-xs"
            :class="logoClass"
            :crm="crm"
            :name="name"
            :show-title="false"
        />

        <slot name="extra" />
    </div>
</template>

<script>
import CrmLogo from '@/components/crm-logo';

export default {
    name: 'CrmLogoLink',
    components: { CrmLogo },
    props: {
        crm: {
            type: String,
            default: 'default',
        },
        name: {
            type: String,
        },
        url: {
            type: String,
        },
        logoClass: {
            type: [Array, Object, String],
        },
    },
    methods: {
        openLink(link) {
            if (!link) return;

            window.open(link, '_blank');
        },
    },
};
</script>
